import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'products',
            name: 'product',
            class: 'Modules\\Product\\Entities\\Product',

            dataTable: {
                headerTopComponents: [
                    {
                        component: 'imp-exp-products-component',
                        bind: {},
                        html: null,
                        on: {}
                    }
                ],
                headerBottomComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ]
            }
        }
    },

    methods: {
        getFormattedMeasureUnit(value) {
            switch(value) {
                case 'MGM':
                    value = 'Miligramos'
                break
        
                case 'GRM':
                    value = 'Gramos'
                break
        
                case 'KGM':
                    value = 'Kilogramos'
                break
        
                case 'MLT':
                    value = 'Mililitros'
                break
        
                case 'LTR':
                    value = 'Litros'
                break
        
                case 'XPK':
                    value = 'Paquete'
                break
        
                case 'H87':
                    value = 'Unidad'
                break
            }
        
            return value
        },

        getFormattedType(value) {
            // switch(value) {
            //     //
            // }
        
            return value
        }
    }
}